module.exports = __webpack_public_path__ + "assets/images/template/project/surgical-mask/wrong.jpg?v=7b34ba46";